import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetActivitiesInProgressCount } from 'domain/usecases/dashboard';

export class RemoteGetActivitiesInProgressCount
  implements GetActivitiesInProgressCount
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetActivitiesInProgressCount.Result>,
  ) {}

  async execute(
    params: GetActivitiesInProgressCount.Params,
  ): Promise<GetActivitiesInProgressCount.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        entity: params.entity,
        course: params.course,
        semester: params.semester,
        curricularUnit: params.curricularUnit,
        groups: params.group,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
